import {DomainEvent} from './DomainEvent';
import {DeletedEntity} from '../resources/DeletedEntity';

export class MatchDeleted extends DomainEvent<DeletedEntity> {}
